
  module.exports =
  {

    search: require('./AreaCode/search'),

    areaCodes: require('./AreaCode/areaCodes'),

  }